/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
    IEC_61508_2010,
    IEC_61508_1998,
    IEC_61511_2016,
    IEC_61511_2003,
} from "const"
import { SilResultSubsystem } from "server/models"
import { SilTarget } from "client/utils"
import { LangType } from "client/store"

import { iec_61508_1998_architecturalConstraints } from "./iec_61508_1998"
import { iec_61508_2010_architecturalConstraints } from "./iec_61508_2010"
import { iec_61511_2003_architecturalConstraints } from "./iec_61511_2003"
import { iec_61511_2016_architecturalConstraints } from "./iec_61511_2016"


export const architecturalConstraintsSubsystem = (
    subsystem: SilResultSubsystem,
    targetSil: SilTarget,
    lang: LangType,
) => {
    const { architecturalConstraints } = subsystem

    // redundancy - devices in subsystem are the same
    let redundancy = true
    const firstDevice = subsystem.blocks[0].projectDevice
    subsystem.blocks.forEach((block) => {
        const { projectDevice } = block
        if (projectDevice !== firstDevice) {
            redundancy = false
        }
    })

    if (architecturalConstraints === IEC_61508_2010) {
        return iec_61508_2010_architecturalConstraints(redundancy, subsystem, lang)
    }
    if (architecturalConstraints === IEC_61508_1998) {
        return iec_61508_1998_architecturalConstraints(redundancy, subsystem, lang)
    }
    if (architecturalConstraints === IEC_61511_2016) {
        return iec_61511_2016_architecturalConstraints(redundancy, subsystem, lang)
    }
    if (architecturalConstraints === IEC_61511_2003) {
        return iec_61511_2003_architecturalConstraints(redundancy, subsystem, targetSil, lang)
    }
    return null
}
